import React from 'react';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <main>
        <Hero />
        <Gallery />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
